export default "__VITE_ASSET__C9UirS3K__"